import { CButton, CCard, CCardBody, CCardText, CCardTitle, CCol, CRow, CSpinner } from '@coreui/react'
import React, { useEffect, useState } from 'react'
import AddEducation from './AddEducations'
import { Plus, X } from 'lucide-react'
import Carder from '../../components/shared/Carder'
import SaveExtra from '../../services/general/saveExtraData.api'
import Pageloader from '../../components/shared/Pageloader'
import { useIndexedDB } from '../../context/IndexedContext'

const ProviderEducation = () => {
  const [loading, setLoading] = useState(false)
  const [modalVisible, setModalVisible] = useState(false)
  const [editEducations, setEditEducations] = useState(null)
  const [allEducationsPost, setAllEducationPost] = useState([])

  const [dbData, setDbData] = useState([])

  const { getEducationMaster } = useIndexedDB()
  useEffect(() => {
    const fetchEducations = async () => {
      const data = await getEducationMaster()
      setAllEducationPost(data)
      setLoading(false)
      setEditEducations(null)
    }
    fetchEducations()
  }, [])

  // const fetchEducationsFromLs = async () => {
  //     setLoading(true);
  //     let data = await SaveExtra('Get_By_Type', 'Education', '', '')

  //     data = JSON.parse(data.d)?.Data || [];
  //     if (data) {
  //         data = data?.map((item) => {
  //             return {
  //                 Id: item.Id,
  //                 Data: JSON.parse(item?.JsonData)
  //             }
  //         })
  //     }

  //     setAllEducationPost(data[0].Data);
  //     setLoading(false);
  //     setEditEducations(null);
  // };

  // useEffect(() => {
  //     fetchEducationsFromLs();
  // }, []);

  const handelSubmit = async (allEducationsPost) => {
    setLoading(true)
    try {
      await SaveExtra('UPDATE', 'Education', JSON.stringify(allEducationsPost), 241)
      fetchEducationsFromLs()
    } catch (error) {
    } finally {
      setLoading(false)
    }
  }

  const handleAddEducations = (newEducation) => {
    if (editEducations !== null) {
      const allUpdated = allEducationsPost?.map((edu) => (edu.id === editEducations.id ? newEducation : edu))
      setAllEducationPost(allUpdated)
      handelSubmit(allUpdated)
      fetchEducationsFromLs()
      setModalVisible(false)
    } else {
      const updatedEducations = [...allEducationsPost, newEducation]
      setAllEducationPost(updatedEducations)
      handelSubmit(updatedEducations)
      fetchEducationsFromLs()
      setModalVisible(false)
    }
  }

  const handleDeleteEducations = (id) => {
    const updatedEducations = allEducationsPost.filter((item) => item.id !== id)
    setAllEducationPost(updatedEducations)
    handelSubmit(updatedEducations)
  }

  const handleEditEducations = (edu) => {
    setEditEducations(edu)
    setModalVisible(true)
  }

  return (
    <>
      <div className=" " style={{ background: '#0E0E0E' }}>
        {/* STATIC TOP BAR */}

        {/* SCROLLABLE SECTION */}
        <div className="  m-1 p-2 " style={{ height: '80vh', overflowY: 'auto' }}>
          <CRow>
            {allEducationsPost?.map((item, idx) => (
              <CCol xs={4} key={idx}>
                <div
                  className="w-100 mb-3"
                  style={{
                    height: '210px',
                    overflow: 'hidden',
                    borderRadius: '20px',

                    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#191919',
                    border: '1px solid gray',
                  }}
                >
                  <div className="  w-100">
                    <div style={{ height: '100px', overflow: 'auto', color: '#dcdcdc', padding: '10px' }}>
                      <h6 style={{ color: '#ffffff', marginBottom: '10px' }}>{item.title}</h6>

                      <p style={{ margin: '0 0' }}>
                        <strong>Category:</strong> {item.category.label}
                      </p>

                      <p style={{ margin: '4px 0' }}>
                        <strong>Sub Category:</strong> {item.subCategory.label}
                      </p>
                    </div>

                    <div style={{ height: '165px', overflow: 'auto' }}>
                      {item.file?.length > 0 ? (
                        <div className="d-flex flex-wrap align-items-center gap-2">
                          {item.file.map((fileItem, i) => {
                            const isImage = fileItem.type === 'image'
                            const isVideo = fileItem.type === 'video'
                            const isDocument = fileItem.type === 'document'

                            return (
                              <div key={i} className="d-flex flex-column gap-2 align-items-center">
                                <a
                                  href={fileItem.url}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="shadow rounded p-2 position-relative d-block"
                                  style={{
                                    width: '100px',
                                    height: '100px',
                                    overflow: 'hidden',
                                    borderRadius: '8px',
                                    cursor: 'pointer',
                                    background: '#191919',
                                    textDecoration: 'none',
                                  }}
                                >
                                  {isVideo ? (
                                    <video
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                      }}
                                      controls
                                    >
                                      <source src={fileItem.url} type="video/mp4" />
                                    </video>
                                  ) : isImage ? (
                                    <img
                                      src={fileItem.url}
                                      alt="Uploaded"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        objectFit: 'cover',
                                        borderRadius: '8px',
                                      }}
                                    />
                                  ) : isDocument ? (
                                    <iframe
                                      src={fileItem.url}
                                      title="Document Viewer"
                                      style={{
                                        width: '100%',
                                        height: '100%',
                                        border: 'none',
                                        borderRadius: '8px',
                                        pointerEvents: 'none', // Non-interactive
                                      }}
                                    />
                                  ) : (
                                    <div
                                      className="text-center"
                                      style={{
                                        color: '#000',
                                        fontSize: '0.75rem',
                                        padding: '10px',
                                      }}
                                    >
                                      {fileItem.fileName || 'File'}
                                    </div>
                                  )}
                                </a>

                                {/* File name link (optional) */}
                                {/* <div
                                    style={{
                                      width: '100px',
                                      height: '20px',
                                      overflow: 'auto',
                                      marginTop: '5px',
                                    }}
                                  >
                                    <a
                                      href={fileItem.url}
                                      target="_blank"
                                      rel="noopener noreferrer"
                                      className="text-dark"
                                      style={{
                                        display: 'inline-block',
                                        padding: '2px 5px',
                                        backgroundColor: '#f0f0f0',
                                        borderRadius: '4px',
                                        fontSize: '0.75rem',
                                        fontWeight: 'bold',
                                        textDecoration: 'none',
                                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                                        transition: 'background-color 0.3s ease',
                                      }}
                                      onMouseOver={(e) => (e.currentTarget.style.backgroundColor = '#e0e0e0')}
                                      onMouseOut={(e) => (e.currentTarget.style.backgroundColor = '#f0f0f0')}
                                    >
                                      {fileItem.fileName || 'File'}
                                    </a>
                                  </div> */}
                              </div>
                            )
                          })}
                        </div>
                      ) : (
                        <div className="text-center text-muted">No files available</div>
                      )}
                    </div>
                  </div>
                </div>
              </CCol>
            ))}
          </CRow>
        </div>
        <Pageloader isLoading={loading} />
      </div>
    </>
  )
}

export default ProviderEducation
